import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import {
  Search,
  Radio,
  Input,
  Dropdown,
  Button,
  Icon,
  Segment,
  Grid,
  Table,
  style,
  Form as FormUi,
} from "semantic-ui-react";
import { branch_Ids, billing_Party_Branch_Ids, billing_Party_Ids } from "../../utils/constant";
import SearchDropdown from "./../createShipmentComponent/searchDropdown";
import MyConsignor from "../dynamicComponent/consignor";
import SearchConsigneeDropDown from "./../createShipmentComponent/searchConsigneeDropDown";
import SearchConsignorDropDown from "./../createShipmentComponent/searchConsignorDropDown";
import SearchRouteDropdown from "./../createShipmentComponent/searchRouteDropdown";
import { translate } from "react-i18next";
import MultiSelect from "react-multi-select-component";
import { Fade, Spinner } from 'react-bootstrap';
import { connect } from "react-redux";
import OrderImportFile from "./orderImportModal";
import ImportVendorAllocation from "./allotVendorModal";
import ReadAxios from "../../components/axiosComponent/read";
import MyTransporterDropDown from "../../components/apiInputs/MyTransporterDropDown";
import DatePicker from "react-datepicker";
import moment from "moment";
import './orderHeader.css'
import { YYYY_MM_DD, ordersHeaderNoImport, order_header_no_primary, order_header_secondary_import_className, statusOptions, LOCAL_STORAGE, FEATURES } from "../../utils/constant";
import axios from 'axios'
import cogoToast from "cogo-toast";
import { TOAST_MESSAGES } from "../../utils/toastMsgConstant";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import MyProductsCat from "../dynamicComponent/myProductCat";
import MyProducts from "../dynamicComponent/myProducts";

const OrdersHeader = (props) => {
  const { t } = props;

  const [statusSelected, setstatusSelected] = useState([]);
  const [ImportModalState, setImportModalState] = useState(false);
  const [AllotVendorModalState, setAllotVendorModalState] = useState(false);
  const [ExportModalState, setExportModalState] = useState(false);



  const [vendorList, setVendorList] = useState([]);
  const [orderReferenceNo, setOrderReferenceNo] = useState("");
  const [blNo, setBlNo] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [transporterNo, setTransporterNo] = useState("");

  const [requiredOn, setRequiredOn] = useState();
  const [endRequiredOn, setEndRequiredOn] = useState();

  const [createdOn, setCreatedOn] = useState();
  const [endCreatedOn, setEndCreatedOn] = useState();
  const [lrNumber, setLrNumber] = useState("");

  const [deliveryReferenceNo, setDeliveryReferenceNo] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [invoiceRefNo, setInvoiceRefNo]= useState("")
  const [orderNo, setOrderNo] = useState("");
  const [vendorLRNo, setVendorLRNo] = useState("");
  const [route, setRoute] = useState("");
  const [consignor, setConsignor] = useState("");
  const [consignee, setConsignee] = useState("");
  const [productId, setProductId] = useState("");
  const [productCatId, setProductCatId] = useState("")

  const [showFilterDiv, setshowFilterDiv] = useState(false);
  const [userMovementTypes, setUserMovementTypes] = useState([])
  const [selected, setSelected] = useState('')

  useEffect(() => {
    getUserMovementTypes();
    getAllVendors();
  }, [props.isLoading]);

  const getUserMovementTypes = () => {
    axios.get(`${process.env.REACT_APP_MASTER_API}/userMovementTypeMapping/${LOCAL_STORAGE.userId}?customerNumber=${LOCAL_STORAGE.customerNo}&userId=${LOCAL_STORAGE.userId}`, {
      headers: {
        Authorization: `${LOCAL_STORAGE.userToken}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    }).then((result) => {
      let movementTypes = []
      result.data.resultSet.map((data) => {
        movementTypes.push(data.movementType.toString().toUpperCase())
      })
      setUserMovementTypes(movementTypes)
      let searchTerm = movementTypes.includes("PRIMARY") ? 'primary' : movementTypes[0].toString().toLowerCase()
      setSelected(searchTerm)
      props.handleFilterChange(searchTerm);
    }).catch((err) => {
      console.log(err);
    })
  }

  let getAllVendors = () => {
    ReadAxios({ url: `vendorMaster/vendors` })
      .then((res) => {
        let vendors = res.data.resultSet;
        let options = [];
        vendors.map((object, index) => {
          let temp = {};
          temp.key = object.transporterCode;
          temp.text = object.transporterName;
          temp.value = object.vendorId;
          return (options[index] = temp);
        });
        setVendorList(options);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let handleStatusChange = (e, data) => {
    if (data.value) {
      setstatusSelected(data.value);
      const sendRequest = (reqiredDatePass, endReqiredDatePass, createdDatePass, endCreatedDatePass) => {
        let searchElement = {
          bl_no: blNo,
          vehicle_no: vehicleNo,
          vendor_id: transporterNo,
          order_reference_no: orderReferenceNo,
          delivery_reference_no: deliveryReferenceNo,
          required_on: reqiredDatePass,
          end_required_on: endReqiredDatePass,
          invoice_no: invoiceNo,
          invoice_reference_no:invoiceRefNo,
          common_order_number: orderNo,
          status: data.value,
          transporter_lr_no: vendorLRNo,
          route_id: route,
          consignor_id: consignor,
          consignee_id: consignee,
          from_order_created_on: createdDatePass,
          to_order_created_on : endCreatedDatePass,
          lr_no : lrNumber,
          product_id : productId,
          product_category_id : productCatId

        };
        props.handleStatusChange(searchElement);
      };

      let reqiredDatePass = "", endReqiredDatePass = "", createdDatePass="", endCreatedDatePass="";
      if (requiredOn) {
        const tempDate = moment(requiredOn, YYYY_MM_DD);
        let month = parseInt(tempDate.month()) + 1;
        if (month < 10) month = "0" + month;
        reqiredDatePass = tempDate.year() + "-" + month + "-" + tempDate.date();
      }
      if (endRequiredOn) {
        const tempDate = moment(endRequiredOn, YYYY_MM_DD);
        let month = parseInt(tempDate.month()) + 1;
        if (month < 10) month = "0" + month;
        endReqiredDatePass = tempDate.year() + "-" + month + "-" + tempDate.date();
      }
      if (createdOn) {
        const tempDate = moment(createdOn, YYYY_MM_DD);
        let month = parseInt(tempDate.month()) + 1;
        if (month < 10) month = "0" + month;
        createdDatePass = tempDate.year() + "-" + month + "-" + tempDate.date();
      }
      if (endCreatedOn) {
        const tempDate = moment(endCreatedOn, YYYY_MM_DD);
        let month = parseInt(tempDate.month()) + 1;
        if (month < 10) month = "0" + month;
        endCreatedDatePass = tempDate.year() + "-" + month + "-" + tempDate.date();
      }
      sendRequest(reqiredDatePass, endReqiredDatePass, createdDatePass, endCreatedDatePass);
    }
  };

  let handleStatusFilterChange = (data) => {
    let temparry = [];
    data.map((item, index) => {
      temparry.push(item.value);
    });
    setstatusSelected(data);
    props.handleStatusChange(temparry);
  };

  let handleFilter = () => {
    setshowFilterDiv(!showFilterDiv);
    if (props?.filterFromCardView) props.handleFilterPadding(!showFilterDiv);
  };

  const handleImportOpen = () => {
    setImportModalState(true);
  };

  const handleAllotVendorModalOpen = () => {
    setAllotVendorModalState(true);
  };
  
  const handleAllotVendorModalClose = (loadingState) => {
    setAllotVendorModalState(false);
    loadingState && window.location.reload()
  };
  
  const handleImportClose = (loadingState) => {
    setImportModalState(false);
    loadingState && window.location.reload()
  };

  const handleExportOpen = () => {
    const isVendorlogin = localStorage.getItem('role') != 'Vendor'
    FEATURES.orderExport_redirect_to_orderReport && isVendorlogin ?
      redirectToOrderReport()
      : props.exporttrueDataGrid("full")
  };

  const redirectToOrderReport = () =>{
    cogoToast.success(TOAST_MESSAGES.REDIRECTING_IN_ORDER_EXPORT).then(()=>{
      props.redirectToOrderReports()
    })
  }

  const handleExportClose = () => {
    setExportModalState(false);
    window.location.reload();
  };

  const checkForOrder = (event, data) => {
    removeBackgoundButton();
    event.target.classList.remove("w3-white");
    event.target.classList.add("w3-blue");
    props.handleFilterChange(data.name);
  };

  const removeBackgoundButton = () => {
    let list = document.getElementsByClassName("button-group-mt");
    for (let i = 0; i < list.length; i++) {
      list[i].classList.remove("w3-blue");
      list[i].classList.add("w3-white");
    }
  };

  const clearFilter = () => {
    setOrderReferenceNo("");
    setBlNo("");
    setVehicleNo("");
    setTransporterNo("");
    setRequiredOn("");
    setEndRequiredOn("");
    setDeliveryReferenceNo("");
    setInvoiceNo("");
    setInvoiceRefNo("");
    setCreatedOn("");
    setEndCreatedOn("");
    setLrNumber("");
    setOrderNo("");
    setVendorLRNo("");
    setRoute("");
    setConsignor("");
    setConsignee("");
    setProductId("");
    setProductCatId("");
    setstatusSelected("");
    sendRequest("","","","");
  };
  

  const searchCall = () => {
    if(!orderReferenceNo && !blNo && !vehicleNo && !transporterNo && !requiredOn && !endRequiredOn && !createdOn && !endCreatedOn &&
      !lrNumber && !deliveryReferenceNo && !invoiceNo && !invoiceRefNo && !orderNo && !vendorLRNo && !route && !consignor && !consignee && !productId && !productCatId){
      cogoToast.error(TOAST_MESSAGES.FILTERS_MESSAGES.NO_FILTERS||"Select any of the filters", {position:"top-right"})
      return;
      }
    if((createdOn && !endCreatedOn) || (!createdOn && endCreatedOn)){
      cogoToast.error(TOAST_MESSAGES.FILTERS_MESSAGES.CREATED_ON_FILTER||"Select both dates for created on filter" , {position:"top-right"})
      return;
    }
    if((requiredOn && !endRequiredOn) || (!requiredOn && endRequiredOn)){
      cogoToast.error(TOAST_MESSAGES.FILTERS_MESSAGES.REQUIRED_ON_FILTER || "Select both dates for required on filter" , {position:"top-right"})
      return;
    }
    let reqiredDatePass = "", endReqiredDatePass = "" ,createdDatePass="", endCreatedDatePass="";
    if (requiredOn) {
      let tempDate = moment(requiredOn, YYYY_MM_DD);
      let month = parseInt(tempDate.month()) + 1;
      if (month < 10) month = "0" + month;
      reqiredDatePass = tempDate.year() + "-" + month + "-" + tempDate.date();
    }
    if (endRequiredOn) {
      let tempDate = moment(endRequiredOn, YYYY_MM_DD);
      let month = parseInt(tempDate.month()) + 1;
      if (month < 10) month = "0" + month;
      endReqiredDatePass = tempDate.year() + "-" + month + "-" + tempDate.date();
    }
    if (createdOn) {
      const tempDate = moment(createdOn, YYYY_MM_DD);
      let month = parseInt(tempDate.month()) + 1;
      if (month < 10) month = "0" + month;
      createdDatePass = tempDate.year() + "-" + month + "-" + tempDate.date();
    }
    if (endCreatedOn) {
      const tempDate = moment(endCreatedOn, YYYY_MM_DD);
      let month = parseInt(tempDate.month()) + 1;
      if (month < 10) month = "0" + month;
      endCreatedDatePass = tempDate.year() + "-" + month + "-" + tempDate.date();
    }
    sendRequest(reqiredDatePass, endReqiredDatePass, createdDatePass, endCreatedDatePass);
  };

  const sendRequest = (reqiredDatePass, endReqiredDatePass, createdDatePass, endCreatedDatePass) => {
    let billingpartbranchIds = billing_Party_Branch_Ids;
    let billingpartIds = billing_Party_Ids;
    let branchIds = branch_Ids;
    let tempbillingpartbranchIds =
    billingpartbranchIds != "" ? billingpartbranchIds.split(",") : [];
    let tempbillingpartIds =
      billingpartIds != "" ? billingpartIds.split(",") : [];
      let tempbranchIds = branchIds != "" ? branchIds.split(",") : [];
      
    let searchElement = {
      booking_branch_ids: tempbranchIds,
      billing_party_ids: tempbillingpartIds,
      billing_party_branch_ids: tempbillingpartbranchIds,
      bl_no: blNo,
      vehicle_no: vehicleNo,
      vendor_id: transporterNo,
      order_reference_no: orderReferenceNo,
      delivery_reference_no: deliveryReferenceNo,
      required_on: reqiredDatePass,
      end_required_on: endReqiredDatePass,
      invoice_no: invoiceNo,
      invoice_reference_no:invoiceRefNo,
      common_order_number: orderNo,
      status: statusSelected,
      transporter_lr_no: vendorLRNo,
      route_id: route,
      consignor_id: consignor,
      consignee_id: consignee,
      from_order_created_on : createdDatePass,
      to_order_created_on : endCreatedDatePass,
      lr_no :lrNumber,
      product_id : productId,
      product_category_id : productCatId
    };
    props.handleMetaSearch(searchElement);
  };

  return (
    <React.Fragment>
      <div id="dispatch_bar">
        <div className="container-fluid dip_bar">
          <div className="row">
            <div className="col-sm-12">
              <div className="d-flex justify-content-between">
                <h2 className="page-title">{props.title}</h2>
                <div className="col-sm-3">
                  <div className="form-inline">
                    {props.showOrderFilterTop && <Button.Group>
                      {order_header_no_primary ? '' :
                        ((userMovementTypes.includes(t("movement_type.values.primary")) && userMovementTypes.length > 1) || userMovementTypes.length === 0) && <Button
                          type="button"
                          className="w3-round button-group-mt w3-blue mt-header-button"
                          name="primary"
                          onClick={(event, data) => checkForOrder(event, data)}
                        >
                          {t("movement_type.buttons.primary") || "Primary"}
                        </Button>}

                      {ordersHeaderNoImport ?
                        ((userMovementTypes.includes(t("movement_type.values.secondary")) && userMovementTypes.length > 1) || userMovementTypes.length === 0) && <Button
                          type="button"
                          className={order_header_secondary_import_className || selected === 'secondary' ? "w3-round button-group-mt w3-blue mt-header-button" : "button-group-mt w3-white mt-header-button"}
                          name="secondary"
                          onClick={(event, data) => checkForOrder(event, data)}
                        >
                          {t("movement_type.buttons.secondary") || "Secondary"}
                        </Button>
                        : null}
                      {ordersHeaderNoImport ? null :
                        <>
                          {((userMovementTypes.includes(t("movement_type.values.import")) && userMovementTypes.length > 1) || userMovementTypes.length === 0) && <Button
                            type="button"
                            className={order_header_secondary_import_className || selected === 'import' ? "w3-round button-group-mt w3-blue mt-header-button" : "button-group-mt w3-white mt-header-button"}
                            name="import"
                            onClick={(event, data) => checkForOrder(event, data)}
                          >
                            {t("movement_type.buttons.import") || "Import"}
                          </Button>}
                          {((userMovementTypes.includes(t("movement_type.values.export")) && userMovementTypes.length > 1) || userMovementTypes.length === 0) && <Button
                            type="button"
                            className={selected === 'export' ? "w3-round button-group-mt w3-blue mt-header-button" : "button-group-mt w3-white mt-header-button"}
                            name="export"
                            onClick={(event, data) => checkForOrder(event, data)}
                          >
                            {t("movement_type.buttons.export") || "Export"}
                          </Button>}
                        </>
                      }
                    </Button.Group>}
                  </div>
                </div>

                <div className="form-inline ui form tiny">
                  <Radio
                    toggle
                    className="mr-1"
                    name="gridView"
                    checked={props.toggle}
                    onChange={props.toggleView}
                    hidden={props.hidden}
                  />

                  {!props?.showSearchFalse && props?.showSearchFalse == false ?
                    null
                    :
                    <Input
                      size="mini"
                      className="mr-1 ml-1"
                      onKeyUp={props.handleSearch}
                      icon={{ name: "search", circular: true }}
                      placeholder={t("action_button.search") || "Search"}
                    />
                  }

                  {(props?.hideNew && props.hideNew == true) ? null :
                    <>
                      {props.permissions.TA_SHIPMENT.CREATE == true ? (
                        <Link
                          to={props.LinkName}
                          className="grey-btn-new"
                        >
                          <i className="fas fa-plus"></i>{" "}
                          {t("action_button.new") || "New"}
                        </Link>
                      ) : null}
                    </>
                  }

                  {props?.hideImport == true ? null : (
                    <button
                      type="button"
                      data-toggle="modal"
                      data-target="#ImportXL"
                      // hidden={props.exportHidden}
                      onClick={() => handleImportOpen()}
                      // className="w3-button w3-small w3-border w3-hover-border-black w3-hover-white w3-border-light-grey ml-1 w3-round"
                      className="grey-btn"
                    >
                      {/* <img
                      src="assets/svg/import.svg"
                      alt=""
                      style={{ width: "11px" }}
                      className="mr-1"
                    /> */}
                      <i class="fas fa-file-import mr-1"></i>
                      {t("action_button.import") || "Import"}
                    </button>
                  )}

                  <button
                    type="button"
                    data-toggle="modal"
                    data-target="#ImportXL"
                    // hidden={props.exportHidden}
                    onClick={() => handleAllotVendorModalOpen()}
                    // className="w3-button w3-small w3-border w3-hover-border-black w3-hover-white w3-border-light-grey ml-1 w3-round"
                    className="grey-btn"
                  >
                    {/* <img
src="assets/svg/import.svg"
alt=""
style={{ width: "11px" }}
className="mr-1"
/> */}
                    <i class="fas fa-file-import mr-1"></i>
                    {t("Allot vendor")}
                  </button>

                  <button
                    type="button"
                    data-toggle="modal"
                    data-target="#ExportXL"
                    disabled={props.isLoading || props.dataPresent == false}
                    // hidden={props.exportHidden}
                    onClick={() => handleExportOpen()}
                    className="grey-btn">
                    <i class="fas fa-file-export mr-1"></i>
                    {props.isLoading ? <small>Loading...</small> :
                      t("action_button.export") || "export"}
                  </button>

                  {/* {!props.isLoading && <button type="button" data-toggle="modal" data-target="#ExportXL" */}
                  {/* onClick={props.exporttrueDataGrid} */}
                  {/* className="grey-btn" > */}
                  {/* <img
                      src="assets/svg/export.svg"
                      alt=""
                      style={{ width: "11px" }}
                      className="mr-1 svg"
                    // /> */}
                  {/* <i class="fas fa-file-export mr-1" size="sm"></i> */}
                  {/* {t("Export") || "Export"} */}
                  {/* </button> */}


                  {/* {props.isLoading && <button type="button" data-toggle="modal" data-target="#ExportXL"
                    className="grey-btn" >
                    <Spinner variant="dark" animation="border" size="sm" className="mr-1" />

                    {t("Export") || "Export"}</button>} */}


                  {/* <button
                    type="button"
                    data-toggle="modal"
                    data-target="#ExportXL"
                    // hidden={props.exportHidden}
                    onClick={props.exporttrueDataGrid}
                    // className="btn-font w3-button w3-small w3-border w3-hover-border-black w3-hover-white w3-border-light-grey ml-1 w3-round"
                    className="grey-btn"
                  >
                    <img
                      src="assets/svg/export.svg"
                      alt=""
                      style={{ width: "11px" }}
                      className="mr-1"
                    />
                    {t("action_button.export") || "Export"}
                  </button> */}

                  {/*} {props.permissions.TA_SHIPMENT.CREATE == true ? (
                    <Link
                      to={props.LinkName}
                      className="btn-font text-decoration-none w3-button w3-hover-border-black w3-hover-white w3-border-light-grey w3-small ml-1 w3-border w3-round"
                    >
                      <i className="fas fa-plus"></i>{" "}
                      {t("action_button.new") || "New"}
                    </Link>
                  ) : null} */}
                  {props.hideFilter
                    ?
                    null
                    :
                    <button
                      size="mini"
                      className="grey-btn-01"
                      onClick={handleFilter}
                      color="#f1f1f1"
                      icon
                    >
                      <Icon name="filter" size="small" />
                      {t("action_button.filter") || "Filter"}
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        {showFilterDiv ==
          true /* && (props.auth.role == "Elixir" || props.auth.role == "Administrator") */ ? (
          props.searchLoading ? 
          <>
          <LoadingPlaceholder /> 
          </> :
          (<>
            <div className="ui fluid container m-2">
              <Segment>
                <FormUi.Group inline>
                  <FormUi.Field>
                    <Grid
                      columns={4}
                      stackable
                      className="width-100cent margin-left-20"
                    >
                      {props?.hideRequired ? null :
                        <Grid.Column>
                          <label>Select Status</label>
                          {props?.showStatusFilter ? (
                            <>
                              <Dropdown
                                multiple
                                selection
                                style={{ width: "100%", fontWeight: "normal" }}
                                // className="mr-2 w3-tiny"
                                onChange={handleStatusChange}
                                options={
                                  props.allotedOrdersStatusShow
                                    ? [
                                      {
                                        key: "1",
                                        text: t("order_status.accepted") || statusOptions.ACCEPTED,
                                        value: "ACK",
                                      },
                                      {
                                        key: "2",
                                        text:
                                          t("order_status.waiting_for_vehicle_details") ||
                                          statusOptions.WAITING_FOR_VEHICLE_DETAILS,
                                        value: "WAITINGVEH",
                                      },
                                    ]
                                    : props.reportingStatusShow ?
                                      [{
                                        key: "1",
                                        text:
                                          t("order_status.allocated") || statusOptions.ALLOCATED,
                                        value: "ALLOC",
                                      },
                                      {
                                        key: "2",
                                        text:
                                          t("order_status.completed") || statusOptions.COMPLETED,
                                        value: "COMPLETE",
                                      }]
                                      :
                                      [
                                        {
                                          key: "1",
                                          text:
                                            t("order_status.allocated") || statusOptions.ALLOCATED,
                                          value: "ALLOC",
                                        },
                                        {
                                          key: "2",
                                          text:
                                            t("order_status.completed") || statusOptions.COMPLETED,
                                          value: "COMPLETE",
                                        },
                                        {
                                          key: "3",
                                          text: t("order_status.accepted") || statusOptions.ACCEPTED,
                                          value: "ACK",
                                        },
                                        {
                                          key: "4",
                                          text:
                                            t("order_status.waiting_for_vehicle_details") ||
                                            statusOptions.WAITING_FOR_VEHICLE_DETAILS,
                                          value: "WAITINGVEH",
                                        },
                                        {
                                          key: "5",
                                          text: t("order_status.rejected") || statusOptions.REJECTED,
                                          value: "REJECT",
                                        },
                                        {
                                          key: "6",
                                          text: t("order_status.created") || statusOptions.CREATED,
                                          value: "CREATED",
                                        },
                                        {
                                          key: "7",
                                          text: t("order_status.broadcasted") || statusOptions.BROADCASTED,
                                          value: "BRDCST",
                                        },
                                        {
                                          key: "8",
                                          text: t("order_status.cancelled") || statusOptions.CANCELLED,
                                          value: "CANCEL",
                                        },
                                      ]
                                }
                                value={statusSelected}
                              />
                            </>
                          ) :
                            <MultiSelect
                              //className="mr-1 checkselect"
                              className="dropdown-content"
                              style={{ width: "100%!important", fontWeight: " " }}
                              options={[
                                {
                                  key: "1",
                                  label:
                                    t("order_status.waiting_for_vehicle_details") ||
                                    "Waiting for vehicle details",
                                  value: "WAITINGVEH",
                                },
                                {
                                  key: "2",
                                  label: t("order_status.allocated") || "Allocated",
                                  value: "ALLOC",
                                },
                                {
                                  key: "3",
                                  label: t("order_status.accepted") || "Accepted",
                                  value: "ACK",
                                },
                                {
                                  key: "4",
                                  label:
                                    t("order_status.broadcasted") || "Broadcasted",
                                  value: "BRDCST",
                                },
                                {
                                  key: "5",
                                  label: t("order_status.cancelled") || "Cancelled",
                                  value: "CANCEL",
                                },
                                {
                                  key: "6",
                                  label: t("order_status.rejected") || "Rejected",
                                  value: "REJECT",
                                },
                                {
                                  key: "7",
                                  label: t("order_status.completed") || "Completed",
                                  value: "COMPLETE",
                                },
                                {
                                  key: "8",
                                  label: t("order_status.created") && "Created",
                                  value: "CREATED",
                                },
                              ]}
                              value={statusSelected}
                              onChange={handleStatusFilterChange}
                              // labelledBy={t("order_status.label") || "Select Status"}
                              overrideStrings={{
                                allItemsAreSelected: "All items are selected.",
                                clearSearch: "Clear Search",
                                noOptions: "No options",
                                search: "Search",
                                selectAll:
                                  t("order_status.select_all") || "Select All",
                                selectSomeItems:
                                  t("order_status.label") || "Select Status",
                              }}
                            />
                          }

                        </Grid.Column>
                      }

                      <Grid.Column>
                        <label>{t("order_header_label.order_reference_number") || "Order Reference Number"}</label>
                        <div className="overflow-hidden width_adjust_input_100">
                          <Input
                            type="text"
                            value={orderReferenceNo}
                            placeholder=""
                            onChange={(e) =>
                              setOrderReferenceNo(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                        </div>
                      </Grid.Column>
                      <Grid.Column className="overflow-hidden">
                        <label className="display-flex-center">BL Number </label>
                        <div className="overflow-hidden width_adjust_input_100">
                          <Input
                            type="text"
                            value={blNo}
                            placeholder=""
                            onChange={(e) => setBlNo(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                        </div>
                        {/* <div className="overflow-hidden width_adjust_input_100">
                <label>BL No. </label>
                  <Input type="text" placeholder="" onChange={(e) => setBlNo(e.target.value)} /> 
                  </div> */}
                      </Grid.Column>

                      {!props?.hideVehicleNumber == true ?
                        <Grid.Column>
                          <label className="display-flex-center">
                            {t("order_header_label.vehicle_number") || "Vehicle Number"}
                          </label>
                          <div className="overflow-hidden width_adjust_input_100">
                            <Input
                              type="text"
                              value={vehicleNo}
                              placeholder=""
                              onChange={(e) => setVehicleNo(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  searchCall()
                                }
                              }}
                            />
                          </div>
                        </Grid.Column>
                        : null}

                      {!props?.hideTransporter == true ?
                        <Grid.Column>
                         { console.log(transporterNo,'transporterNumber>>')}
                          <label>{t("order_header_label.transporter") || "Transporter"}</label>
                          <MyTransporterDropDown value={transporterNo} idValue={true} handleChange={(event, data) => setTransporterNo(data?.value || '')} />
                        </Grid.Column>
                        : null}


                      <Grid.Column>
                        <label>{t("order_header_label.delivery_reference_no") || "Delivery Reference Number"}</label>
                        <div className="overflow-hidden width_adjust_input_100">
                          <Input
                            type="text"
                            placeholder=""
                            value={deliveryReferenceNo}
                            onChange={(e) =>
                              setDeliveryReferenceNo(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                        </div>
                      </Grid.Column>
                      <Grid.Column>
                        <label>{t("order_header_label.invoice_no") || "Invoice Number"}</label>
                        <div className="overflow-hidden width_adjust_input_100">
                          <Input
                            type="text"
                            placeholder=""
                            value={invoiceNo}
                            onChange={(e) =>
                              setInvoiceNo(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                        </div>
                      </Grid.Column>

                      <Grid.Column>
                        <label>{t("order_header_label.invoice_reference_no") || "Invoice Reference Number"}</label>
                        <div className="overflow-hidden width_adjust_input_100">
                          <Input
                            type="text"
                            placeholder=""
                            value={invoiceRefNo}
                            onChange={(e) =>
                              setInvoiceRefNo(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                        </div>
                      </Grid.Column>

                      <Grid.Column>
                        <label>{t("order_header_label.order_no") || "Order Number"}</label>
                        <div className="overflow-hidden width_adjust_input_100">
                          <Input
                            type="text"
                            placeholder=""
                            value={orderNo}
                            onChange={(e) =>
                              setOrderNo(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                        </div>
                      </Grid.Column>

                      <Grid.Column>
                        <label>{t("order_header_label.required_on") || "Required On Date"}</label>
                        <FormUi.Field className="overflow-hidden width_adjust_100 display-flex-center-justify-spacebtwn">
                          <DatePicker
                            isClearable
                            style={{ width: "100%!important" }}
                            className="form-control width-100cent"
                            dateFormat="dd/MM/yyyy"
                            selected={requiredOn}
                            value={requiredOn}
                            maxDate={endRequiredOn}
                            onChange={(date) => setRequiredOn(date)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                          <span>-</span>
                          <DatePicker
                            isClearable
                            style={{ width: "100%!important" }}
                            className="form-control width-100cent"
                            dateFormat="dd/MM/yyyy"
                            minDate={requiredOn}
                            required={endRequiredOn}
                            selected={endRequiredOn}
                            onChange={(date) => setEndRequiredOn(date)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                        </FormUi.Field>
                      </Grid.Column>
                      <Grid.Column>
                        <label>{t("order_header_label.vendor_lr_no") || "Vendor LR Number"}</label>
                        <div className="overflow-hidden width_adjust_input_100">
                          <Input
                            type="text"
                            placeholder=""
                            value={vendorLRNo}
                            onChange={(e) =>
                              setVendorLRNo(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                        </div>
                      </Grid.Column>
                      <Grid.Column>
                        <label>{"Route"}</label>
                        <SearchRouteDropdown
                          value={route}
                          handleChange={(event, data) =>
                            setRoute(data.value)
                          } />
                      </Grid.Column>
                      <Grid.Column>
                        <label>{"Consignor"}</label>
                        <SearchConsignorDropDown
                         value={consignor}
                          handleChange={(event, data) =>
                            setConsignor(data?.value)
                          } />
                      </Grid.Column>
                      <Grid.Column>
                        <label>{"Consignee"}</label>
                        <SearchConsigneeDropDown
                        value={consignee}
                          handleChange={(event, data) => setConsignee(data?.value)} />
                      </Grid.Column>

                      <Grid.Column>
                        <label>{t("order_header_label.created_on") || "Created On Date"}</label>
                        <FormUi.Field className="overflow-hidden width_adjust_100 display-flex-center-justify-spacebtwn">
                          <DatePicker
                            isClearable
                            style={{ width: "100%!important" }}
                            className="form-control width-100cent"
                            dateFormat="dd/MM/yyyy"
                            selected={createdOn}
                            value={createdOn}
                            maxDate={endCreatedOn}
                            onChange={(date) => setCreatedOn(date)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                          <span>-</span>
                          <DatePicker
                            isClearable
                            style={{ width: "100%!important" }}
                            className="form-control width-100cent"
                            dateFormat="dd/MM/yyyy"
                            minDate={createdOn}
                            value={endCreatedOn}
                            selected={endCreatedOn}
                            onChange={(date) => setEndCreatedOn(date)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                        </FormUi.Field>
                      </Grid.Column>

                      <Grid.Column>
                        <label>{t("order_header_label.lr_no") || "LR Number"}</label>
                        <div className="overflow-hidden width_adjust_input_100">
                          <Input
                            type="text"
                            placeholder=""
                            value={lrNumber}
                            onChange={(e) =>
                              setLrNumber(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                searchCall()
                              }
                            }}
                          />
                        </div>
                      </Grid.Column>

                      {FEATURES.productFilterEnabled &&
                        <>
                        <Grid.Column>
                        <label>{t("order_header_label.product") || "Product"}</label>
                        <div className="">
                          <MyProducts 
                          field={{name : "product_id"}}
                          form={{setFieldValue : (name, value)=> {
                            setProductId(value)
                          }}}
                          idValue = {true}
                          showNameAndCode = {true}
                          value={productId}
                          disabled={false}
                          clearable
                          search
                           />
                        </div>
                      </Grid.Column>

                      <Grid.Column>
                        <label>{t("order_header_label.product_category") || "Product Category"}</label>
                        <div className="">
                          <MyProductsCat 
                          field={{name : "product_category_id"}}
                          form={{setFieldValue : (name, value)=> {
                            setProductCatId(value)
                          }}}
                          showNameAndCode = {true}
                          value={productCatId}
                          clearable
                          />
                        </div>
                      </Grid.Column>
                      </>
                      }

                    </Grid>
                    
                    <Grid centered columns={2}>
                      <div className="mt-20 row">
                        <FormUi.Field>
                          <Button className="w3-button w3-small w3-border ml-1 w3-round" onClick={clearFilter}>
                            Clear
                          </Button>
                        </FormUi.Field>
                        <FormUi.Field>
                          <Button className="w3-button w3-small w3-border w3-blue w3-hover-blue ml-1 w3-round" onClick={searchCall}>
                            Search
                          </Button>
                        </FormUi.Field>
                      </div>
                    </Grid>
                    <br></br>
                  </FormUi.Field>
                </FormUi.Group>
              </Segment>
            </div>

              {/* <Segment className="ui form tiny">
              <FormUi.Group inline className="display-flex-center">
                <FormUi.Field>
                  { <label>Select Movement Type</label>
                  <Dropdown
                    //className="mr-1 checkselect"
                    name="movement_type"
                    clearable
                    style={{ width: '100%', fontWeight: "normal" }}
                    // disabled={disable}
                    selection
                    placeholder={
                      t("order_type.placeholder") ||
                      "Movement Type"
                    }
                    onChange={(name, data) => checkForOrder(name, data)}
                    options={[
                      { key: "2", text: "Import", value: "import" },
                      { key: "3", text: "Primary", value: "primary" },
                      { key: "1", text: "Export", value: "export" },
                    ]}
                    defaultValue={"primary"}
                  /> }
                </FormUi.Field>
                <FormUi.Field />
                <FormUi.Field >
                  {<label>Select Status</label>
                  <MultiSelect
                    //className="mr-1 checkselect"
                    className=""
                    style={{ width: '100%!important', fontWeight: " " }}
                    options={[
                      { key: "1", label: t("order_status.waiting_for_vehicle_details") || "Waiting for vehicle details", value: "WAITINGVEH" },
                      { key: "2", label: t("order_status.allocated") || "Allocated", value: "ALLOC" },
                      { key: "3", label: t("order_status.accepted") || "Accepted", value: "ACK" },
                      { key: "4", label: t("order_status.broadcasted") || "Broadcasted", value: "BRDCST" },
                      { key: "5", label: t("order_status.cancelled") || "Cancelled", value: "CANCEL" },
                      { key: "6", label: t("order_status.rejected") || "Rejected", value: "REJECT" },
                      { key: "7", label: t("order_status.completed") || "Completed", value: "COMPLETE" },
                    ]}
                    value={statusSelected}
                    onChange={handleStatusFilterChange}
                    // labelledBy={t("order_status.label") || "Select Status"} 
                    overrideStrings={{
                      "allItemsAreSelected": "All items are selected.",
                      "clearSearch": "Clear Search",
                      "noOptions": "No options",
                      "search": "Search",
                      "selectAll": t("order_status.select_all") || "Select All",
                      "selectSomeItems": t("order_status.label") || "Select Status"
                    }
                    } />}
                  
                </FormUi.Field>
                <FormUi.Field />
                <FormUi.Field className="overflow-hidden width_adjust_input_100">
                  <label>Order Reference No</label>
                  <Input type="text" placeholder="" onChange={(e) => setOrderReferenceNo(e.target.value)} />
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline className="display-flex-center">
                <FormUi.Field className="overflow-hidden width_adjust_input_100">
                  <label>BL No</label>
                  <Input type="text" placeholder="" onChange={(e) => setBlNo(e.target.value)} /> 
                </FormUi.Field>
                <FormUi.Field />
                <FormUi.Field className="overflow-hidden width_adjust_input_100">
                  <label>Vehicle No</label>
                  <Input type="text" placeholder="" onChange={(e) => setVehicleNo(e.target.value)} />
                </FormUi.Field>
                <FormUi.Field />
                <FormUi.Field className="width_adjust_100">
                  <label>Transporter</label>
                  <Dropdown
                    //className="mr-1 checkselect"
                    name="vendor_list_master"
                    clearable
                    style={{ width: '100%', fontWeight: "normal" }}
                    // disabled={disable}
                    selection
                    onChange={(name, data) => setTransporterNo(data.value)}
                    options={vendorList}
                  />
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline className="display-flex-center">
                <FormUi.Field className="overflow-hidden width_adjust_input_100">
                  <label>Delivery Reference No</label>
                  <Input type="text" placeholder="" onChange={(e) => setDeliveryReferenceNo(e.target.value)} />
                </FormUi.Field> 
                <FormUi.Field />
                 <FormUi.Field className="overflow-hidden width_adjust_100">
                  <label>Required On</label>
                  <DatePicker
                    isClearable
                    style={{ width: '100%!important' }}
                    className="form-control width-100cent"
                    dateFormat="dd/MM/yyyy"
                    selected={requiredOn} onChange={(date) => setRequiredOn(date)} />
                </FormUi.Field> 
                <FormUi.Field />
                <FormUi.Field className="overflow-hidden" />
              </FormUi.Group>

              <FormUi.Group centered>
                {/* <FormUi.Field width={3}>
                  <Button className="w3-button w3-small w3-border w3-white w3-hover-white ml-1 w3-round" onClick={clearFilter}>Clear Filter</Button>
                </FormUi.Field> */}
            {/*} <FormUi.Field>
                  <Button className="w3-button w3-small w3-border w3-blue w3-hover-blue ml-1 w3-round" onClick={searchCall}>Search</Button>
                </FormUi.Field> }
              </FormUi.Group>
            </Segment > */}
          </>)
        ) : null}
      </div>
      <OrderImportFile
        openBox={ImportModalState}
        handleClose={handleImportClose}
        fileName={props.baseURL}
        baseURL={props.baseURL}
        allotedOrder={props.allotedOrder || false}
      /> 
      <ImportVendorAllocation
      openBox={AllotVendorModalState}
      handleClose={handleAllotVendorModalClose}
      fileName={props.baseURL}
      baseURL={props.baseURL}
      allotedOrder={props.allotedOrder || false}
    />
    </React.Fragment>
  );
};
const mapStateToProps = ({ permissions, auth }) => {
  return {
    permissions,
    auth,
  };
};
export default connect(mapStateToProps)(translate("orders")(OrdersHeader));
